export const SHIFT_KEY_MOVE_ELEMENT_BY_DELTA_X = 10;
export const MOVE_ELEMENT_BY_DELTA_X = 1;
export const PAGE_RESIZE_SCROLL_SPACING = 250;
export const HEIGHT_PAGE_RESIZE_BUTTON_SPACING_FROM_PAGE_ELEMENT = 80;
export const WIDTH_PAGE_RESIZE_BUTTON_SPACING_FROM_PAGE_ELEMENT = 30;
export const KEY_SCOPE_NAME = 'mouseCatcher';
